/* Channel Canna: in-place recipe card for the home recipe board
   (sections/recipe-board.liquid). Each card is a plain link to the Recipes
   page (the no-JS fallback); with this file a plain click opens that recipe
   in the section's <dialog> instead, so the shopper stays on the home page.
   Content comes from the card's server-rendered <template data-rcd-tpl>.
   Modified clicks (new tab, etc.) keep the link behaviour.
   Shop button: goes to the lineup tab for that coffee (#lnx-panel-joe /
   #lnx-panel-tini), never to a formula (no-default formula rule). */
(function () {
  'use strict';
  if (window.__ccRecipeDialog) return;
  window.__ccRecipeDialog = true;

  var LOCK = 'rcd-lock';

  function init(root) {
    if (!root || root.dataset.rcdReady) return;
    var dlg = root.querySelector('[data-rcd]');
    if (!dlg || typeof dlg.showModal !== 'function') return; // old browser: links stay links
    root.dataset.rcdReady = '1';

    var title = dlg.querySelector('[data-rcd-title]');
    var body = dlg.querySelector('[data-rcd-body]');
    var shop = dlg.querySelector('[data-rcd-shop]');
    var closeBtn = dlg.querySelector('[data-rcd-close]');
    var opener = null;
    var leaving = false;

    root.querySelectorAll('[data-rcd-open]').forEach(function (a) {
      a.setAttribute('aria-haspopup', 'dialog');
    });

    function open(handle, from) {
      var tpl = root.querySelector('template[data-rcd-tpl="' + handle + '"]');
      if (!tpl) return false;
      var base = tpl.dataset.base === 'tini' ? 'tini' : 'joe';
      title.textContent = tpl.dataset.name || '';
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      // Reuse the card's inline icon instead of shipping each SVG twice.
      var slot = body.querySelector('[data-rcd-icon]');
      var svg = from && from.querySelector('svg');
      if (slot && svg) {
        var c = svg.cloneNode(true);
        c.setAttribute('width', '72'); c.setAttribute('height', '72');
        slot.appendChild(c);
      } else if (slot) { slot.parentNode.removeChild(slot); }
      if (shop) {
        shop.href = shop.dataset[base === 'tini' ? 'shopTini' : 'shopJoe'];
        shop.textContent = 'Shop ' + (tpl.dataset.baseName || (base === 'tini' ? 'Canna Tini' : 'Canna Joe'));
        shop.dataset.ccHandle = base;
      }
      opener = from || null;
      leaving = false;
      document.documentElement.classList.add(LOCK);
      dlg.showModal();
      var sheet = dlg.querySelector('[data-rcd-sheet]');
      if (sheet) sheet.scrollTop = 0;
      // Focus the heading so screen readers start at the recipe name; Tab reaches Close next.
      title.focus({ preventScroll: true });
      return true;
    }

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove(LOCK);
      if (!leaving && opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    });

    // Esc fires 'cancel' then 'close' natively; nothing extra needed.
    closeBtn.addEventListener('click', function () { dlg.close(); });

    // Backdrop click: the dialog box itself has no padding, so a click whose
    // target is the <dialog> element landed on the ::backdrop.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });

    // Shop / "See all" links: close first, then let the browser follow the link.
    dlg.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || !dlg.contains(link)) return;
      leaving = true;
      document.documentElement.classList.remove(LOCK); // before the jump, not on the async 'close'
      dlg.close();
    });

    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-rcd-open]');
      if (!a || !root.contains(a) || dlg.contains(a)) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (open(a.dataset.rcdOpen, a)) e.preventDefault();
    });
  }

  function scan(scope) {
    var r = scope || document;
    r.querySelectorAll('[data-rc-board]').forEach(init);
    if (r.matches && r.matches('[data-rc-board]')) init(r);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function () { document.documentElement.classList.remove(LOCK); });
})();
